const GENERIC_ERROR = 'Something went wrong. Please try again.';
const CONNECTION_ERROR = 'Request failed. Check your connection and try again.';

const getApiErrorMessage = (error, fallback = GENERIC_ERROR) => {
  if (error && error.message === 'Network Error') return CONNECTION_ERROR;

  const data = error && error.response && error.response.data;
  if (data && typeof data === 'object' && data.message) return data.message;

  return (error && error.message) || fallback;
};

export default getApiErrorMessage;
